import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/logo_klikin.png';
import driver_f1 from '../../assets/template/driver_f1.jpeg';
import doctor from '../../assets/template/doctor.jpeg';
import pilot from '../../assets/template/pilot.jpeg';
import police from '../../assets/template/police.jpeg';
import musician from '../../assets/template/musician.jpeg';
import athlete from '../../assets/template/athlete.jpeg';
import teacher from '../../assets/template/teacher.jpeg';
import scientist from '../../assets/template/scientist.jpeg';
import chef from '../../assets/template/chef.jpeg';
import architect from '../../assets/template/architect.jpeg';
import entrepreneur from '../../assets/template/entrepreneur.jpeg';
import firefighter from '../../assets/template/firefighter.jpeg';
import software_engineer from '../../assets/template/software_engineer.jpeg';
import ninja from '../../assets/template/ninja.jpeg';
import samurai from '../../assets/template/samurai.jpeg';
import superhero from '../../assets/template/superhero.jpeg';
import redcarpet  from '../../assets/template/redcarpet.jpeg';

const QUESTIONS = [
  {
    key: 'template',
    title: 'Whats your dream?',
    options: [
      {
        image: redcarpet,
        label: 'Red Carpet',
        value: `a premium luxury Hollywood red carpet fashion, elegant high-fashion styling, professional formalwear, modest and sophisticated designer outfit, fully covered and tasteful styling appropriate to the original appearance and cultural context. Replace the background with a backdrop Hollywood red carpet event.`
      },
      {
        image: superhero,
        label: 'Superhero',
        value: `
a random premium futuristic superhero suit with a flowing cape. Background modern futuristic city skyline and heroic atmosphere.`
      },

      {
        image: ninja,
        label: 'Ninja',
        value: `
a random premium black shinobi outfit with traditional ninja details. Background ancient Japanese village and mysterious atmosphere.`
      },
      {
        image: samurai,
        label: 'Samurai',
        value: `
 a random detailed traditional samurai armor and carrying a katana. Background Japanese temple and cinematic warrior atmosphere.`
      },
      {
        image: doctor,
        label: 'Doctor',
        value: `
a random white premium lab coat with stethoscope premium and medical equipment. background hospital setting and a modern atmosphere.`
      },

      {
        image: pilot,
        label: 'Pilot',
        value: `
a random premium indonesian pilot uniform. background airport runway and a modern atmosphere.`
      },

      {
        image: driver_f1,
        label: 'Formula F1 Driver',
        value: `
a random premium Formula 1 driver. background formula1 car and a modern racetrack with grandstands and a vibrant atmosphere.`
      },

      {
        image: police,
        label: 'Police Officer',
        value: `
a random premium indonesian police uniform. background police station and a modern urban atmosphere.`
      },

      {
        image: musician,
        label: 'Musician',
        value: `
a random rock star outfit. background concert stage and a premium music venue atmosphere.`
      },

      {
        image: athlete,
        label: 'Athlete',
        value: `
 a random athletic outfit based on their gender. background olympic arena and a modern sports atmosphere.`
      },
      {
        image: teacher,
        label: 'Teacher',
        value: `
an official Indonesian civil servant teacher uniform, neat khaki uniform with name tag and official details. Modern classroom environment with desks, whiteboard, educational materials, and a clean academic atmosphere.`
      },
      {
        image: scientist,
        label: 'Scientist',
        value: `
a random white premium lab coat with lab equipment. background laboratory setting and a modern atmosphere.`
      },
      {
        image: chef,
        label: 'Chef',
        value: `
a random white premium chef coat with kitchen utensils. background professional kitchen setting and a modern culinary atmosphere.`
      },
      {
        image: architect,
        label: 'Architect',
        value: `
a random white safety helmet, rolled-up dress shirt, dark trousers, and a reflective safety vest. Holding architectural plans. Modern building construction site in the background. Professional architecture and engineering atmosphere.`
      },
      {
        image: entrepreneur,
        label: 'Entrepreneur',
        value: `
a random elegant tailored suit, luxury watch, and sophisticated business attire. Standing confidently in a modern executive office background a city skyline. Premium corporate environment.`
      },
      {
        image: software_engineer,
        label: 'Software Engineer',
        value: `
a random smart casual tech attire. Background modern technology workspace with multiple monitors, coding environment, and an innovative startup atmosphere.`
      },

      {
        image: firefighter,
        label: 'Firefighter',
        value: `
a random premium firefighter uniform with safety gear. Background fire station and emergency response vehicles in a modern atmosphere.`
      }
    ]
  }

  // {
  //   key: 'inspiration',
  //   title: 'What inspires you most?',
  //   options: [
  //     {
  //       value: 'creativity',
  //       label: 'Creativity',
  //       image:
  //         'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=200'
  //     },
  //     {
  //       value: 'innovation',
  //       label: 'Innovation',
  //       image:
  //         'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=200'
  //     },
  //     {
  //       value: 'exploration',
  //       label: 'Exploration',
  //       image:
  //         'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=200'
  //     },
  //     {
  //       value: 'music',
  //       label: 'Music',
  //       image:
  //         'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200'
  //     },
  //     {
  //       value: 'achievement',
  //       label: 'Achievement',
  //       image:
  //         'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=200'
  //     },
  //     {
  //       value: 'leadership',
  //       label: 'Leadership',
  //       image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=200'
  //     },
  //     {
  //       value: 'discovery',
  //       label: 'Discovery',
  //       image:
  //         'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=200'
  //     },
  //     {
  //       value: 'learning',
  //       label: 'Learning',
  //       image:
  //         'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=200'
  //     },
  //     {
  //       value: 'nature',
  //       label: 'Nature',
  //       image:
  //         'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=200'
  //     },
  //     {
  //       value: 'possibility',
  //       label: 'Possibility',
  //       image:
  //         'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=200'
  //     }
  //   ]
  // },

  // {
  //   key: 'dream_world',
  //   title: 'What does your dream world look like?',
  //   options: [
  //     {
  //       value: 'futuristic',
  //       label: 'Futuristic',
  //       image:
  //         'https://images.unsplash.com/photo-1519608487953-e999c86e7455?w=200'
  //     },
  //     {
  //       value: 'tropical',
  //       label: 'Tropical',
  //       image:
  //         'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=200'
  //     },
  //     {
  //       value: 'nature',
  //       label: 'Nature',
  //       image:
  //         'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=200'
  //     },
  //     {
  //       value: 'modern_city',
  //       label: 'Modern City',
  //       image:
  //         'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=200'
  //     },
  //     {
  //       value: 'cinematic',
  //       label: 'Cinematic',
  //       image:
  //         'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=200'
  //     },
  //     {
  //       value: 'creative_studio',
  //       label: 'Creative Studio',
  //       image:
  //         'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=200'
  //     },
  //     {
  //       value: 'mountain_escape',
  //       label: 'Mountain Escape',
  //       image:
  //         'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=200'
  //     },
  //     {
  //       value: 'ocean_horizon',
  //       label: 'Ocean Horizon',
  //       image:
  //         'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=200'
  //     },
  //     {
  //       value: 'space_frontier',
  //       label: 'Space Frontier',
  //       image:
  //         'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=200'
  //     },
  //     {
  //       value: 'urban_lights',
  //       label: 'Urban Lights',
  //       image: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=200'
  //     }
  //   ]
  // }
];

const PageQuestion = () => {
  const navigate = useNavigate();
  const [currentQuestion, setCurrentQuestion] = useState(0);

  const handleAnswer = (option) => {
    const existing = JSON.parse(localStorage.getItem('photobooth_data')) || {};

    const answers = existing.answers || {};

    answers[QUESTIONS[currentQuestion].key] = {
      value: option.value,
      label: option.label
    };

    localStorage.setItem(
      'photobooth_data',
      JSON.stringify({
        ...existing,
        answers
      })
    );

    if (currentQuestion < QUESTIONS.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    } else {
      navigate('/capture');
    }
  };

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#0f1020] text-white">
      {/* Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#8b5cf620,transparent_45%)]" />

      <div className="relative z-10 flex h-full flex-col px-6 py-8">
        {/* Header */}
        <div>
          <p className="flex justify-center items-center text-center text-xs font-bold uppercase tracking-[0.4em] text-violet-300">
            <img src={Logo} className="h-10 w-auto object-fit-contain" />
          </p>

          {/* Progress Dots */}
          <div className="mt-8 flex justify-center gap-2">
            {QUESTIONS.map((_, index) => (
              <div
                key={index}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index <= currentQuestion
                    ? 'w-8 bg-violet-400'
                    : 'w-2 bg-white/20'
                }`}
              />
            ))}
          </div>
          {/*
          <p className="mt-4 text-center text-sm text-zinc-400">
            Pertanyaan {currentQuestion + 1} dari {QUESTIONS.length}
          </p> */}
        </div>

        {/* Question */}
        <div className="relative mt-4 flex-1 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentQuestion}
              initial={{ opacity: 0, x: 80 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -80 }}
              transition={{ duration: 0.25 }}
              className="absolute inset-0 flex flex-col">
              <h2 className="mb-6 text-center text-2xl font-black leading-tight">
                {QUESTIONS[currentQuestion].title}
              </h2>

              <div className="min-h-0 flex-1 no-scrollbar overflow-y-auto pr-1">
                <div className="grid grid-cols-2 gap-4 pb-4">
                  {QUESTIONS[currentQuestion].options.map((option) => (
                    <motion.button
                      key={option.value}
                      whileTap={{ scale: 0.97 }}
                      onClick={() => handleAnswer(option)}
                      className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]">
                      <img
                        src={option.image}
                        alt={option.label}
                        className="aspect-square w-full object-cover object-top"
                      />

                      <div className="p-4">
                        <p className="text-center text-sm font-bold">
                          {option.label}
                        </p>
                      </div>
                    </motion.button>
                  ))}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default PageQuestion;
